/**
 * Pluralize a word based on a given count.
 * This works for words that can be pluralized by adding an 's' at the end by default.
 * If the word has an irregular plural form, you can pass the plural form as the third argument.
 *
 * @param word - The word to pluralize.
 * @param count - The count to determine if the word should be pluralized.
 * @param plural - The plural form of the word. If not provided, the word will be pluralized by adding an 's' at the end.
 *
 * @example
 * pluralizeWord('cat', 1) // 'cat'
 * pluralizeWord('cat', 0) // 'cats'
 * pluralizeWord('cat', 2) // 'cats'
 *
 * pluralizeWord('half', 1, 'halves') // 'half'
 * pluralizeWord('half', 0, 'halves') // 'halves'
 */
export const pluralizeWord = <
  Word extends string,
  Count = number,
  PluralWord extends string = `${Word}s`,
>(
  word: Word,
  count: Count,
  plural: PluralWord = `${word}s` as PluralWord,
) => {
  if (Number(count) === 1) {
    return word;
  }
  return plural;
};
